import { ICadApiContext } from "@iventis/cad-georeferencer/src/context/cad-api-context";
import axios from "axios";

export const createCadApiContext = (sitemapVersionLevelId: string): ICadApiContext => {
    const isLocalHost = window.location.hostname.includes("localhost");
    let url = "";
    if (isLocalHost) {
        url = `https://cad-api.admin-dashboard-dev.iventis.com/${sitemapVersionLevelId}/`;
    } else {
        url = `${window.location.origin.replace("://", "://cad-api.")}/${sitemapVersionLevelId}/`;
    }
    return {
        async getConfig() {
            const { data } = await axios.get(`${url}config`);
            return data;
        },
        async updateConfig(config) {
            const { data } = await axios.put(`${url}config`, config);
            return data;
        },
        apiUrl: url,
        async getGeoJsonLayers() {
            const { data } = await axios.get(`${url}layers`);
            return data;
        },
        async shutdownApi() {
            await axios.post(`${url}shutdown`);
        },
    };
};
